import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';
import InfiniteLooper from '../../InfiniteLooper';
import { divideArrayIntoSubArrays } from '../../../utils/arrays';

export const AnimatedLogosPure = ({ title = undefined, logos = [], shapes }) => {
  const [visible] = React.useState(true);

  // React.useEffect(() => {
  //   setTimeout(() => {
  //     setVisible(true);
  //   }, 100);
  // }, []);

  return (
    <div className={cn(styles.logos, { [styles.visible]: visible })}>
      {shapes && (
        <>
          {/** decorative shapes, loaded via Gatsby image pipeline */}
          <div className={styles.shapeTop}>
            <GatsbyImage image={getImage(shapes.shapeTop)} alt="" loading="lazy" decoding="async" />
          </div>
          <div className={styles.shapeBottom}>
            <GatsbyImage
              image={getImage(shapes.shapeBottom)}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>
        </>
      )}
      <div className={cn(styles.logosInner)}>
        <h4 className={styles.title}>{title || 'Serving 1000s of Customers'}</h4>

        {logos?.map((images, idx) => {
          const direction = idx % 2 === 0 ? 'right' : 'right';

          return (
            <div className={styles.imagesRow} key={`images-row-${idx}`}>
              <InfiniteLooper speed={60 + idx * 2} direction={direction}>
                {images?.map(({ node }) => {
                  const image = getImage(node.childImageSharp);

                  if (!image) return null;

                  return (
                    <GatsbyImage
                      key={`${node.id}-${idx}`}
                      image={image}
                      alt={node.name || ''}
                      loading="lazy"
                      decoding="async"
                      className={styles.logoImage}
                    />
                  );
                })}
              </InfiniteLooper>
            </div>
          );
        })}
      </div>
    </div>
  );
};

AnimatedLogosPure.propTypes = {
  title: PropTypes.string,
  logos: PropTypes.array,
  shapes: PropTypes.shape({
    shapeTop: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    shapeBottom: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }),
};

const AnimatedLogos = ({ title = undefined }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "logos" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(width: 200, formats: [AUTO, WEBP], placeholder: NONE, quality: 90)
            }
          }
        }
      }
      shapeTop: file(relativeDirectory: { eq: "animated-logos" }, name: { eq: "logos-shape" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [AUTO, WEBP], quality: 70)
        }
      }
      shapeBottom: file(relativeDirectory: { eq: "animated-logos" }, name: { eq: "shape-bottom" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [AUTO, WEBP], quality: 70)
        }
      }
    }
  `);

  const logos = divideArrayIntoSubArrays(data.allFile.edges, 3);
  const shapes = {
    shapeTop: data.shapeTop.childImageSharp.gatsbyImageData,
    shapeBottom: data.shapeBottom.childImageSharp.gatsbyImageData,
  };

  return <AnimatedLogosPure title={title} logos={logos} shapes={shapes} />;
};

AnimatedLogos.propTypes = {
  title: PropTypes.string,
};

export default AnimatedLogos;
